module.exports = __webpack_public_path__ + "static/media/onboard_b_files.75591a47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/onboard_b_files.svg
// module id = 2713
// module chunks = 0